import { createOccupationDisplayList } from 'logics/createOccupationInitialList';
import { useState, ChangeEvent } from 'react';
import { OccupationDisplayListType } from 'types/occupation';

/**
 * 職種のチェックボックスに関するカスタムフック
 * @param occupationInitialList 職種の初期配列
 * @returns 職種の値と更新する関数を含むオブジェクト
 */
export const useOccupation = (
  occupationInitialList: OccupationDisplayListType[]
) => {
  const [occupationDisplayList, setOccupationDisplayList] = useState<
    OccupationDisplayListType[]
  >(occupationInitialList);

  const occupationLList = occupationDisplayList;
  const occupationMList = occupationDisplayList.flatMap(
    (mList) => mList.jobTypeMList
  );
  const occupationSList = occupationDisplayList.flatMap((mList) =>
    mList.jobTypeMList.flatMap((sList) => sList.jobTypeSList)
  );

  // 選択中の大分類のid配列
  const selectedOccupationLIdList = occupationLList
    .filter(({ isChecked }) => isChecked)
    .map(({ searchJobTypeId }) => searchJobTypeId);

  // 選択中の中分類のid配列
  const selectedOccupationMIdList = occupationMList
    .filter(({ isChecked }) => isChecked)
    .map(({ searchJobTypeId }) => searchJobTypeId);

  // 選択中の小分類のid配列
  const selectedOccupationSIdList = occupationSList
    .filter(({ isChecked }) => isChecked)
    .map(({ searchJobTypeId }) => searchJobTypeId);

  // 大分類のチェックボックス更新処理
  const updateIsCheckedOccupationLList = (
    event: ChangeEvent<HTMLInputElement>,
    selectedId: string
  ) => {
    const checkedList = occupationLList.map((occupation) => {
      if (occupation.searchJobTypeId !== selectedId) return occupation;
      return {
        ...occupation,
        isChecked: event.target.checked,
      };
    });

    const checkedOccupationDisplayList: OccupationDisplayListType[] =
      createOccupationDisplayList({
        occupationLList: checkedList,
        occupationMList,
        occupationSList,
      });
    setOccupationDisplayList(checkedOccupationDisplayList);

    return checkedList
      .filter(({ isChecked }) => isChecked)
      .map(({ searchJobTypeId }) => searchJobTypeId);
  };

  // 中分類のチェックボックス更新処理
  const updateIsCheckedOccupationMList = (
    event: ChangeEvent<HTMLInputElement>,
    selectedId: string
  ) => {
    const checkedList = occupationMList.map((occupation) => {
      if (occupation.searchJobTypeId !== selectedId) return occupation;
      return {
        ...occupation,
        isChecked: event.target.checked,
      };
    });

    const checkedOccupationDisplayList: OccupationDisplayListType[] =
      createOccupationDisplayList({
        occupationLList,
        occupationMList: checkedList,
        occupationSList,
      });
    setOccupationDisplayList(checkedOccupationDisplayList);

    return checkedList
      .filter(({ isChecked }) => isChecked)
      .map(({ searchJobTypeId }) => searchJobTypeId);
  };

  // 小分類のチェックボックス更新処理
  const updateIsCheckedOccupationSList = (
    event: ChangeEvent<HTMLInputElement>,
    selectedId: string
  ) => {
    const checkedList = occupationSList.map((occupation) => {
      if (occupation.searchJobTypeId !== selectedId) return occupation;
      return {
        ...occupation,
        isChecked: event.target.checked,
      };
    });

    const checkedOccupationDisplayList: OccupationDisplayListType[] =
      createOccupationDisplayList({
        occupationLList,
        occupationMList,
        occupationSList: checkedList,
      });
    setOccupationDisplayList(checkedOccupationDisplayList);

    return checkedList
      .filter(({ isChecked }) => isChecked)
      .map(({ searchJobTypeId }) => searchJobTypeId);
  };

  // チェック状態クリア処理
  const clearIsCheckOccupationList = () => {
    setOccupationDisplayList([]);
  };

  return {
    setOccupationDisplayList,
    occupationDisplayList,
    selectedOccupationLIdList,
    selectedOccupationMIdList,
    selectedOccupationSIdList,
    clearIsCheckOccupationList,
    updateOccupationFunctions: {
      updateIsCheckedOccupationLList,
      updateIsCheckedOccupationMList,
      updateIsCheckedOccupationSList,
    },
  };
};
